<template>
    <div id='offers-list-event' class="offers-list-wrapper" tabindex="0">
        <div class="page-title">
            <h4> {{$t('txt.listaOferte')}} </h4>
        </div>
        <div class="page-header-inner">
            <div class="table-header">
                <div class="search-box">
                    <div class="search-form">
                        <input
                                type="search"
                                name="q"
                                :placeholder="$t('placeholder.cautaOferta')"
                                id="user-search"
                                v-model="search"
                                autocomplete="off"
                                @change="applyQuery({ q: search })"
                        >
                        <span class="focus-input"></span>
                        <span class="symbol-input" @click="applyQuery({ q: search })">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                    <button type="button" class="template-button" @click="$router.push('/offers/create')" v-if="$can(['create offer'])">
                        <i class="fas fa-plus-circle"></i> {{$t('txt.adaugaOferta')}}
                    </button>
                </div>
            </div>
            <!--<div class="filters-section">
                <div class="show-filters" v-on:click="showFilters = !showFilters">
                    <i class="fas fa-angle-double-right first-angle"></i>
                    <h4>
                        {{$t('txt.filtreazaDupa')}}:
                    </h4>
                    <i class="fas fa-angle-double-left second-angle"></i>
                </div>
                <div class="filters-wrapper-inner" :class="{fwi_active:showFilters}">
                    <div class="filters-wrapper-main">
                        <div class="filters-select">
                            <div class="filterSelection">
                                <label> {{$t('placeholder.judet')}}: </label>
                                <v-select v-model="filters.county" :options="this.counties" label="name"
                                          @input="getCitiesByCounty()" placeholder="Judet"></v-select>
                            </div>
                            <div class="filterSelection">
                                <label> {{$t('placeholder.oras')}} </label>
                                <v-select v-model="filters.city" :options="this.cities" label="name"></v-select>
                            </div>
                        </div>
                    </div>
                    <div class="filters-button">
                        <button type="button" class="reset-filters" @click="resetFilters()">
                            <i class="fas fa-undo"></i>
                            {{$t('txt.reseteazaFiltre')}}
                        </button>
                        <button type="button" @click="filterUsers()">
                            {{$t('txt.filtreaza')}}
                            <i class="fas fa-filter"></i>
                        </button>
                    </div>
                    <div class="close-filters" v-on:click="showFilters = !showFilters">
                        <i class="far fa-times-circle"></i>
                    </div>
                </div>
            </div>-->
        </div>
        <div class="utilities-result-wrapper" v-if="this.$route.query.q">
            <p class="search-result" v-if="this.$route.query.q">
                <i class="fas fa-poll-h"></i>
                {{$t('txt.cautareDupa')}} "{{this.searchBy}}"
            </p>
        </div>
        <div class="mobile-sorting">
            <div class="mobile-sort-by">
                <v-select :options="this.tableColumns"
                          v-model="sortMobile.sortMobileBy"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="tableHeader"
                          :placeholder="$t('txt.sorteazaDupa')">
                </v-select>
            </div>
            <div class="mobile-sort-method">
                <v-select :options="this.mobileSortingType"
                          v-model="sortMobile.sortMobileType"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="name"
                          :placeholder="$t('txt.criteriuSortare')">
                </v-select>
            </div>
        </div>
        <div class="offers-legend-template">
            <p class="offer-sent" @click="filterUsers( 1  )"> Trimisa </p>
            <p class="offer-pending" @click="filterUsers( 2  )"> In negociere </p>
            <p class="offer-won" @click="filterUsers( 3  )"> Castigata </p>
            <p class="offer-lost" @click="filterUsers( 4 )"> Pierduta </p>
            <p class="offer-incomplete" @click="filterUsers( 5 )"> Incompleta </p>
            <p class="offer-canceled" @click="filterUsers( 6 )"> Anulata </p>
            <div class="reset-sort-status" @click="resetOfferStatus()">
                <p class="status-dots-wrapper">
                    <span class="dot dot-sent"></span>
                    <span class="dot dot-pending"></span>
                    <span class="dot dot-won"></span>
                </p>
                <p class="hidden-text"> Reseteaza  </p>
                <p class="status-dots-wrapper">
                    <span class="dot dot-lost"></span>
                    <span class="dot dot-incomplete"></span>
                    <span class="dot dot-canceled"></span>
                </p>
            </div>
        </div>
        <table class="table app_table" id="table-resize">
            <thead>
            <tr class="app_table_header">
                <th scope="col" v-for="(column, index) in tableColumns" :key="index">
                    <span v-if="column.sortable" @click="handleSort(column.sortBy)" >
                        {{column.tableHeader}}
                        <span class="sort-arrow" v-if="$route.query.sort_by === column.sortBy && $route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                        <span class="sort-arrow" v-else-if="$route.query.sort_by === column.sortBy && $route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                        <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </span>
                    <span v-else>
                        {{column.tableHeader}}
                    </span>
                </th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="results">
                <tr v-for="(row, index) in results" :key="index" :data-active="index" @click="lastDataActive = index" :class="statusColor.find(value => value.status === row.status).label" @dblclick="$router.push({ name: 'viewoffer', params: { id: row.id }})" @keyup.enter="$router.push({ name: 'viewoffer', params: { id: row.id }})" tabindex="3" :id="'popover-' + index" variant="primary">
                    <td v-for="(column, indexColumn) in tableColumns" :key="indexColumn" :tableheadData="column.tableHeader">
                          <span v-if="column.sortBy === 'id'">
                            {{row['id']}}
                        </span>
                        <span v-else-if="column.sortBy === 'user'">
                            {{(row['user']) ? clientName(row['user']) : '-'}}
                        </span>
                        <span v-else-if="column.sortBy === 'client'">
                            {{(row['client']) ? clientName(row['client']) : '-'}}
                        </span>
                        <span v-else-if="column.sortBy === 'colaborator'">
                            {{(row['partner']) ? clientName(row['partner']) : '-'}}
                        </span>
                        <span v-else>
                            {{(row[column.value]) ? row[column.value] : '-'}}
                        </span>
                    </td>
                    <td :tableheadData="$t('tableHeader.optiuni')" class="options-case">
                        <a :href="row.media[row.media.length - 1]['link']"
                           class="convo-doc" target="_blank"
                           v-if="row.media[0] && $can(['view offer'])" data-placement="top"
                           data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')"
                        >
                            <i class="far fa-file-alt"></i>
                        </a>
                        <router-link tabindex="1" :to="{ name: 'viewoffer', params: { id: row.id }}" class="view-user" v-if="$can(['view offer'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                            <i class="fas fa-eye"></i>
                        </router-link>
                        <router-link tabindex="1" :to="{ name: 'editoffer', params: { id: row.id }}" class="edit-user" v-if="$can(['update offer'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                            <i class="fas fa-pen"></i>
                        </router-link>
                        <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip" v-if="$can(['delete offer'])"
                           :title="$t('placeholder.sterge')" @click="remove(index, row.id)">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                        <router-link tabindex="1" :to="{ name: 'cloneOffer', params: { id: row.id }}" class="edit-user" v-if="$can(['create offer'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.cloneaza')">
                            <i class="far fa-clone"></i>
                        </router-link>
                        <a href='#' @click="downloadResource(exportLink + row.id)" title="Export excel" class="delete-user" data-placement="top" data-toggle="tooltip" v-if="$can(['view offer'])">
                            <i class="fas fa-download"></i>
                        </a>
                    </td>
                    <b-popover :target="'popover-' + index" triggers="hover focus" placement="bottomleft" delay="100">
                        <template slot="title">
                            Produse
                        </template>

                        <ol class="popover-content">
                            <li v-for="product in row.products" :key="product.id">
                                <p>
                                    {{product.name}}
                                </p>
                            </li>
                            <li  v-for="service in row.services" :key="service.id">
                                <p>
                                    {{service.name}}
                                </p>
                            </li>
                            <li v-for="post_service in row.post_services" :key="post_service.id">
                                <p>
                                    {{post_service.name}}
                                </p>
                            </li>
                        </ol>
                    </b-popover>
<!--                    <ul class="test-info">-->
<!--                        <li>-->
<!--                           <p>Lorem ipsum dolor sit amet.  </p>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <p> Lorem ipsum dolor sit amet. </p>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <p> Lorem ipsum dolor sit amet. </p>-->
<!--                        </li>-->
<!--                    </ul>-->
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="7" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                    <td colspan="7" v-else>{{$t('errors.emptyResult')}}</td>
                </tr>
            </tbody>
            <tfoot v-if="results">
                <tr class="app_table_header">
                    <th scope="col" v-for="(column, index) in tableColumns" :key="index">
                        {{column.tableHeader}}
                    </th>
                    <th scope="col">
                        {{$t('tableHeader.optiuni')}}
                    </th>
                </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="results">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import OffersService from '../../api-services/offers.service.js'
export default {
  name: 'Offers',
  data () {
    return {
      statusColor: [
        { label: 'row-status-sent', status: 'oferta trimisa' },
        { label: 'row-status-pending', status: 'in negociere' },
        { label: 'row-status-won', status: 'castigata' },
        { label: 'row-status-lost', status: 'pierduta' },
        { label: 'row-status-incomplete', status: 'incompleta' },
        { label: 'row-status-canceled', status: 'anulata' },
        { label: 'row-status-default', status: null }
      ],
      tableColumns: [
        {
          sortBy: 'id',
          tableHeader: this.$t('tableHeader.id'),
          sortable: true,
          value: ''
        },
        {
          sortBy: 'user',
          tableHeader: this.$t('tableHeader.user'),
          sortable: true,
          value: ''
        },
        {
          sortBy: 'client',
          tableHeader: this.$t('tableHeader.client'),
          sortable: true,
          value: ''
        },
        {
          sortBy: 'colaborator',
          tableHeader: this.$t('tableHeader.colaborator'),
          sortable: true,
          value: ''
        },
        {
          sortBy: 'data',
          tableHeader: this.$t('tableHeader.data'),
          sortable: true,
          value: 'created_at'
        },
        /* {
          sortBy: 'subtotal',
          tableHeader: this.$t('tableHeader.subtotal'),
          sortable: true,
          value: 'subtotal'
        }, */
        {
          sortBy: 'objective',
          tableHeader: this.$t('tableHeader.obiectiv'),
          sortable: true,
          value: 'objective'
        },
        {
          sortBy: 'representative_products',
          tableHeader: this.$t('tableHeader.produseReprezentative'),
          sortable: true,
          value: 'representative_products'
        },
        {
          sortBy: 'total',
          tableHeader: this.$t('tableHeader.total'),
          sortable: true,
          value: 'total'
        },
        {
          sortBy: 'status',
          tableHeader: 'Status',
          sortable: false,
          value: 'status'
        }
      ],
      sortMobile: {
        sortMobileBy: null,
        sortMobileType: null
      },
      results: null,
      counties: [],
      cities: [],
      filters: {
        client: null,
        user: null,
        per_page: 25
      },
      mobileSorting: [
        { key: 'user', name: 'User' },
        { key: 'client', name: 'Client' },
        { key: 'data', name: 'Data' },
        { key: 'subtotal', name: 'Subtotal' },
        { key: 'discount', name: 'Discount' },
        { key: 'total', name: 'Total' }
      ],
      mobileSortingType: [
        { key: 'ASC', name: 'Crescator' },
        { key: 'DESC', name: 'Descrescator' }
      ],
      search: '',
      searchBy: this.$route.query.q || null,
      showFilters: (this.$route.query.f_county && this.$route.query.f_county > 0) || (this.$route.query.f_city && this.$route.query.f_city > 0),
      meta: {},
      offer_status: null,
      lastDataActive: null,
      exportLink: process.env.VUE_APP_API_ENDPOINT + '/export/offer/'
    }
  },
  watch: {
    search: function (value) {
      if (!value) {
        this.applyQuery({ q: value })
      }
    },
    '$route.query' () {
      this.getOffers()
    }
  },
  computed: {
    sortMobileBy () {
      return (this.sortMobile.sortMobileBy) ? this.sortMobile.sortMobileBy.sortBy : null
    },
    sortMobileType () {
      return (this.sortMobile.sortMobileType) ? this.sortMobile.sortMobileType.key : null
    },

    // return first page from pagination html
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return parseInt(this.meta.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return parseInt(this.meta.current_page, 10) + 2
      } else {
        return this.meta.last_page
      }
    },
    // return only 5 pages for pagination
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    getOffers () {
      this.results = null
      this.$store.dispatch('showLoading')
      OffersService.getAll()
        .then((response) => {
          if (response.data.data.length > 0) {
            this.results = response.data.data
          } else {
            this.results = null
          }
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    // getCounties () {
    //   CountiesService.getAll({ per_page: -1 })
    //     .then((response) => {
    //       this.counties = response.data.data
    //       if (this.$route.query.f_county) {
    //         let countyId = parseInt(this.$route.query.f_county)
    //         this.filters.county = this.counties.find(county => county.id === countyId)
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
    // getCitiesByCounty (countyId) {
    //   this.cities = []
    //   this.filters.city = ''
    //   if (!countyId && (this.filters.county && this.filters.county.id)) {
    //     countyId = this.filters.county.id
    //   }
    //   if (countyId && countyId > 0) {
    //     let countyId = (this.filters.county && this.filters.county.id) ? this.filters.county.id : this.$route.query.f_county
    //     CountiesService.get(countyId)
    //       .then((response) => {
    //         this.cities = response.data.data.cities
    //         if (this.$route.query.f_city) {
    //           this.filters.city = this.cities.find(city => city.id === parseInt(this.$route.query.f_city))
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error)
    //       })
    //   }
    // },
    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'offers', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    },
    handleSortMobile (column, type) {
      if (column) {
        if (!this.sortMobile.sortMobileBy) {
          let found = this.tableColumns.find(function (element) {
            return element.name === column
          })
          this.sortMobile.sortMobileBy = found
        }
        if (type) {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === type
            })
            this.sortMobile.sortMobileType = found
          }
        } else {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === 'ASC'
            })
            this.sortMobile.sortMobileType = found
          }
          type = this.sortMobile.sortMobileType.key
        }
        this.applyQuery({ sort_by: column, sort_type: type })
      } else {
        this.applyQuery({ sort_by: null, sort_type: null })
      }
    },
    filterUsers (status) {
      if (status) {
        this.offer_status = status
        this.applyQuery({ offer_status: this.offer_status })
      } else if (this.filters.county && this.filters.city) {
        this.applyQuery({ f_county: this.filters.county.id, f_city: this.filters.city.id, offer_status: this.offer_status })
      } else if (this.filters.county) {
        // let newRouteQuery = _.omit(this.$route.query, 'f_city')
        // this.$router.replace( { query: newRouteQuery } )
        this.applyQuery({ f_county: this.filters.county.id, f_city: 0, offer_status: this.offer_status })
      } else {
        this.applyQuery({ f_county: 0, f_city: 0, offer_status: this.offer_status })
      }
      this.showFilters = false
    },
    resetFilters () {
      this.filters.city = null
      this.filters.county = null
      this.applyQuery({ f_county: 0, f_city: 0, page: 1 })
      this.showFilters = false
    },
    resetOfferStatus () {
      this.applyQuery({ offer_status: 0 })
    },
    remove (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeOferta'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          OffersService.delete(id)
            .then((response) => {
              this.$delete(this.results, index)
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    }
  },
  mounted () {
    window.$('#offers-list-event').focus()
    let vm = this
    document.getElementById('offers-list-event').addEventListener('keydown', event => {
      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.closest('.offers-list-wrapper') !== null) {
        event.preventDefault()
        let target = window.$('html, body')
        if (event.keyCode === 40) {
          vm.lastDataActive = vm.lastDataActive == null ? 0 : vm.lastDataActive + 1
          if (vm.lastDataActive > this.results.length) {
            vm.lastDataActive--
          }
          if (vm.lastDataActive === this.results.length) {
            target.animate({
              scrollTop: target.height()
            }, 'fast')
            window.$('[data-active=' + vm.lastDataActive + ']').focus()
            return false
          }
        } else {
          vm.lastDataActive = vm.lastDataActive < 1 ? 0 : vm.lastDataActive - 1
          if (vm.lastDataActive === 3) {
            target.animate({
              scrollTop: 0
            }, 'fast')
            window.$('[data-active=' + vm.lastDataActive + ']').focus()
            return false
          }
        }
        window.$('[data-active=' + vm.lastDataActive + ']').focus()
      }
    })
  },
  created () {
    let query = this.$route.query
    if (query.q) this.search = query.q
    // this.getCounties()
    if (query.sort_by && query.sort_type) {
      this.handleSortMobile(query.sort_by, query.sort_type)
    } else if (query.sort_by) {
      this.handleSortMobile(query.sort_by)
    }
    // if (query.f_county) this.getCitiesByCounty(query.f_county)
    this.getOffers()
  }
}
</script>
